import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin, Globe } from 'lucide-react';
import Logo from './Logo';
import { contactInfo } from '../mock';

const Footer = () => {
  const visaCountries = [
    { name: 'Dubai Visa', path: '/visa/dubai' },
    { name: 'Thailand Visa', path: '/visa/thailand' },
    { name: 'Singapore Visa', path: '/visa/singapore' },
    { name: 'Schengen Visa', path: '/visa/schengen' },
    { name: 'UK Visa', path: '/visa/uk' },
    { name: 'Canada Visa', path: '/visa/canada' }
  ];

  const destinations = [
    { name: 'Kashmir Tour', path: '/destinations/kashmir' },
    { name: 'Sikkim Tour', path: '/destinations/sikkim' },
    { name: 'Bali Tour', path: '/destinations/bali' },
    { name: 'Dubai Tour', path: '/destinations/dubai' },
    { name: 'Thailand Tour', path: '/destinations/thailand' },
    { name: 'Vietnam Tour', path: '/destinations/vietnam' }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="site-footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Logo variant="light" className="text-white mb-4" />
            <p className="text-sm mt-4 mb-3">
              Surat&apos;s trusted partner for visa consulting, international tours, flight and hotel bookings.
            </p>
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-3 py-2 rounded-lg mb-4">
              <span className="text-xs uppercase tracking-wider text-[#F7945D] font-semibold">Powered by</span>
              <Link to="/thailand-dmc" className="text-sm font-bold text-white hover:text-[#F7945D]">
                Varni<span className="text-[#F7945D]">2</span>Fly Thailand
              </Link>
            </div>
            <div className="flex gap-3">
              {[Facebook, Instagram, Twitter, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 bg-gray-800 hover:bg-[#2D8DB4] rounded-full flex items-center justify-center transition-colors" aria-label="Social link">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Visa Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Popular Visas</h3>
            <ul className="space-y-2 text-sm">
              {visaCountries.map((v) => (
                <li key={v.path}>
                  <Link to={v.path} className="hover:text-[#F7945D] transition-colors">{v.name}</Link>
                </li>
              ))}
              <li className="pt-1 border-t border-gray-800 mt-2">
                <Link to="/visa-services" className="text-[#F7945D] hover:text-white text-sm font-medium">View All Visa Services →</Link>
              </li>
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Destinations</h3>
            <ul className="space-y-2 text-sm">
              {destinations.map((d) => (
                <li key={d.path}>
                  <Link to={d.path} className="hover:text-[#F7945D] transition-colors">{d.name}</Link>
                </li>
              ))}
              <li className="pt-1 border-t border-gray-800 mt-2">
                <Link to="/tour-packages" className="text-[#F7945D] hover:text-white text-sm font-medium">View All Packages →</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Get In Touch</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-[#F7945D]" />
                <span>105 Anupam Business Hub, Yogi Chowk, Surat, Gujarat, India</span>
              </li>
              {contactInfo.phones.map((phone) => (
                <li key={phone}>
                  <a href={`tel:${phone}`} className="flex items-center gap-2 hover:text-[#F7945D]">
                    <Phone size={14} className="text-[#F7945D]" /> {phone}
                  </a>
                </li>
              ))}
              {contactInfo.emails.map((email) => (
                <li key={email}>
                  <a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-[#F7945D]">
                    <Mail size={14} className="text-[#F7945D]" /> {email}
                  </a>
                </li>
              ))}
              <li>
                <a href="https://www.varnivisa.com" className="flex items-center gap-2 hover:text-[#F7945D]">
                  <Globe size={14} className="text-[#F7945D]" /> www.varnivisa.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-2 text-sm">
          <p>&copy; {2019} Varni Visa. All rights reserved.</p>
          <div className="flex gap-4 flex-wrap">
            <Link to="/about" className="hover:text-[#F7945D]">About</Link>
            <Link to="/thailand-dmc" className="hover:text-[#F7945D]">Thailand DMC</Link>
            <Link to="/b2b/login" className="hover:text-[#F7945D]">B2B Portal</Link>
            <Link to="/contact" className="hover:text-[#F7945D]">Contact</Link>
            <Link to="/blog" className="hover:text-[#F7945D]">Blog</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
